<!--
 * @Author: 317473294@qq.com
 * @Date: 2022-06-01 15:34:47
 * @LastEditTime: 2024-10-10 15:26:15
 * @LastEditors: 317473294@qq.com
 * @Description: 
 * @FilePath: /frontEnd/src/components/common/Menu.vue
-->
<template>
  <div class="menus">
    <div class="log">
      <el-button  style="width: 210px;height: 60px; font-size: 20px;background-color: #374a61;border: 0;" type="warning" size="mini">寰铭管理系统</el-button>
    </div>
    <el-aside class="layout-aside" width="210px">
  
      <!-- router 激活，才能在item里面使用 -->
      <el-menu default-active="1-4-1" class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose"
        :collapse="isCollapse" active-text-color="#fff" router>
        <div  v-for="(item, index) in menus" :key="index">
          <!-- index必须字符串，后面加空的字符串就不会报错了 -->
          <el-submenu :index="index + ''" :key="index" v-if="item.hidden">
           
            <template slot="title">
              <i :class="item.icon"></i>
              <span slot="title">{{ item.name }}</span>
            </template>
            <el-menu-item-group v-for="(child, index) in item.children" :key="index">
              <el-menu-item :index="child.path" :route="child.path">
                <i :class="child.icon"></i> 
                {{ child.name }}
              </el-menu-item>
            </el-menu-item-group>
          </el-submenu>
        </div>
      </el-menu>

      <!--     @open="handleOpen"
      @close="handleClose" :style="{height:getBorwseHeight}" :default-openeds="defaultOpenMenu"  @select="onSelectMenu"-->
      <!-- <el-menu :default-active="activeMenu" 
      :collapse-transition="true"  
      class="el-menu-vertical-demo" 
      :collapse="isCollapse" 
      > -->
      <!-- 引入el-sub-menu组件 -->
      <!-- <menu-tree :menuData="menus"></menu-tree>
    </el-menu> -->
    </el-aside>
  </div>
</template>
<script>
  import { getMenu, addMenus, updataMenu, deleteMenu } from "@/api/menu.js"
   import MenuTree from '@/components/menu/MenuTree.vue'
   import {tranArrToTreeData} from "@/router/dtRouter.js"
export default {
  name: "Menu",
  components:{
    MenuTree
  },
  data() {
    return {
      activeMenu:"1",
      isCollapse: false,
      menus: []
    };
  },
  created() {
    //  let routers=this.$router.options.routes
    // this.menus = [...this.$router.options.routes];//从路由表中拿菜单
    //  //console.log("菜单：",this.$router) 
    // this.initData()
    // //console.log("==>ok")
   let stateMenu=this.$store.state.menus//本地存储拿权限菜单
   //console.log("menu菜单数据",stateMenu)
  //  let menuTree=tranArrToTreeData(JSON.parse(stateMenu))
   this.menus=stateMenu
  
   
  },
  methods: {
        //初始化，从服务器加载数据
        initData() {
                getMenu().then((res) => {
                    // //console.log("读取课程目录数据", res.data.data)
                    const data = res.data.data
                      const treedata=this.$tools.tranArrToTreeData(data)
                      this.$nextTick(()=>{
                        this.menus = treedata
                      })
                      
                      //console.log("menu菜单数据",treedata)
                 
                })
            },
    handleOpen(key, keyPath) {
      //console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      //console.log(key, keyPath);
    }
  }
}
</script>
<style lang="less" scoped>
.menus{
  transition: width 0.28s;
  width: 210px !important;
    height: 100%;
    position: fixed;
    font-size: 0px;
    top: 0;
    bottom: 0;
    left: 0;
    z-index: 1001;
    overflow: hidden;
    background-color: @primaryColor;
    /* overflow-y: auto; */
}
/deep/.el-aside{
height: 100%;
/* overflow: hidden; */
overflow-y: auto;
height: 700px;
}
/deep/.el-menu{

/* height: 500px; */
background-color: #304156;
background: @primaryColor;
color: @primaryTextColor;
overflow-y: hide;

}
/deep/.el-submenu{
min-width: 0;
}
/deep/.el-menu-item{
  min-width: 0;
  color: #fff;
  background-color: #304156;
}
/deep/.el-submenu__title{
  color: #fff;
}
/deep/.el-submenu__title:hover{
  color: #fff;
  background-color: #1f2a38;
}
/deep/.el-menu-item:hover{
  color: #fff;
  background-color: #1f2a38;
}

/deep/.el-submenu__title>span{
  margin-right: 70px;
 
}
.log{
  display: flex;
  justify-content: center;
  align-items: center;
  width: 210px;
  height: 60px;
  background-color: #304156;
  color: #fff;
}
.layout-aside{
  overflow-y: auto;
    height: auto;
    position: fixed;
    bottom: 0;
    top: 60px;
}
</style>


// WEBPACK FOOTER //
// src/components/common/Menu.vue